export default __webpack_public_path__ + "static/media/rstudio-icon.f59cf917.ico";